export default __webpack_public_path__ + "static/media/filter.245dbcf3.svg";